// extracted by mini-css-extract-plugin
export default {"MarkHolder":"ToDoItem_MarkHolder__r29S5"};